module.exports = {"attributes":{"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M11.284 0H13.481L8.68117 5.93026L14.3278 14H9.90653L6.44363 9.10574L2.48128 14H0.28293L5.41685 7.65692L0 0H4.53352L7.66368 4.47354L11.284 0ZM10.5129 12.5785H11.7303L3.87202 1.34687H2.56563L10.5129 12.5785Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
